export const homeTranslations = {
  en: {
    'home.seoTitle': 'Championship 2A & 4A Yo-Yos by Asia Pacific Champion Cheng Hao Yi',
    'home.seoDescription': "Performance 2A and 4A offstring yo-yos engineered by Cheng Hao Yi, China's first-ever 2A Asia Pacific Champion. Shop BlitzBall, Wind Ball, Rainbow Windball, Hidden Loong and Destiny signature.",
    'home.credentials': 'Brand credentials',
    'home.trust.national': '5× China National Champion',
    'home.trust.asiaPacific': '2018 Asia Pacific 2A Champion',
    'home.trust.first': "China's First 2A Asian Champion",
    'home.trust.team': '9 Team Athletes',
    'home.storyEyebrow': 'Our Story',
    'home.storyTitle': 'Born From Competition.',
    'home.storyBody': 'YCH-YOYO is founded and engineered by Cheng Hao Yi, five-time China National 2A Champion and the first Chinese player ever to claim the Asia Pacific 2A title. Every yo-yo we ship carries that pedigree, from the legendary BlitzBall to our newest offstring releases.',
    'home.atAGlance': 'YCH-YOYO at a glance',
    'home.stat.products': 'Products in Collection',
    'home.stat.athletes': 'Team Athletes',
    'home.stat.titles': 'National 2A Titles',
    'home.stat.first': 'Chinese 2A Asian Champion',
    'home.stat.firstValue': '1st',
    'home.meetTeam': 'Meet the Team',
    'home.ready': 'Ready to Play?',
    'home.join': 'Join the Champions.',
    'home.finalSub': 'Pick your first champion-grade yo-yo, or learn which model fits your style.',
    'home.shop': 'Shop the Collection',
    'home.guide': 'BlitzBall vs Wind Ball Guide',
    'home.worldwide': 'Worldwide shipping',
    'home.seeShipping': 'See shipping',
    'home.readStory': 'Read our story',
    'hero.eyebrow': 'Championship-Grade 2A & 4A Yo-Yos',
    'hero.titleFirst': 'Built by Champions.',
    'hero.titleSecond': 'Engineered to Win.',
    'hero.subtitle': "From the workshop of Cheng Hao Yi, China's first-ever 2A Asia Pacific Champion. Performance loops and offstring throws trusted by competitors worldwide.",
    'hero.watch': 'Watch the Champion',
    'hero.scroll': 'Scroll to credentials',
    'carousel.eyebrow': 'Championship Collection',
    'carousel.title': 'Yo-Yos for Every Stage of Your Game.',
    'carousel.navigation': 'Carousel navigation',
    'carousel.previous': 'Previous product',
    'carousel.next': 'Next product',
    'carousel.region': 'Championship Collection',
    'carousel.roleDescription': 'carousel',
    'carousel.view': 'View {{name}}',
    'carousel.fromPrice': 'From {{price}}',
    'carousel.explore': 'Explore',
    'carousel.tagline.1': "The original champion's loop.",
    'carousel.tagline.8': 'Speed. Control. Endless flow.',
    'carousel.tagline.21': 'The Wind Ball, evolved.',
    'carousel.tagline.14': 'Offstring made for everyone.',
    'carousel.tagline.6': 'Zirui Qiu Signature.',
    'carousel.badge.1': 'Champion Series',
    'carousel.badge.8': 'Best Seller',
    'carousel.badge.21': 'New Color',
    'carousel.badge.14': '4A Offstring',
    'carousel.badge.6': 'Signature',
    'timeline.founderAlt': 'Cheng Hao Yi, founder of YCH-YOYO',
    'timeline.founder': 'Founder & Engineer',
    'timeline.quote': '“I want every player who picks up a YCH yo-yo to feel what world-class 2A really means.”',
    'timeline.achievements': 'Career achievements',
    'timeline.title.1': '5× China National 2A Champion',
    'timeline.title.2': '4th — Iceland World Championship',
    'timeline.title.3': 'Asia Pacific 2A Champion',
    'timeline.title.4': '5th — Shanghai World Championship',
    'timeline.note.first': "China's first 2A Asian Champion",
    'timeline.tag.national': 'National',
    'timeline.tag.world': 'World',
    'timeline.tag.asiaPacific': 'Asia Pacific',
    'timeline.videoTitle': 'Cheng Hao Yi performance — YCH-YOYO',
    'windball.alt': 'Wind Ball Yo-Yo',
    'windball.pill': 'Our Main Hero',
    'windball.subtitle': 'Light, durable, and endlessly fun.',
    'windball.buy': 'Buy Now',
  },
  ja: {
    'home.seoTitle': 'アジアパシフィック王者 Cheng Hao Yi が手掛ける競技用2A・4Aヨーヨー',
    'home.seoDescription': '中国初の2Aアジアパシフィック王者Cheng Hao Yiが設計する2A・4A競技用ヨーヨー。BlitzBall、Wind Ball、Rainbow Windball、Hidden Loong、Destinyをご覧ください。',
    'home.credentials': 'ブランド実績',
    'home.trust.national': '中国全国大会 5回優勝',
    'home.trust.asiaPacific': '2018年アジアパシフィック2A優勝',
    'home.trust.first': '中国初の2Aアジア王者',
    'home.trust.team': 'チーム選手9名',
    'home.storyEyebrow': '私たちの物語',
    'home.storyTitle': '競技から生まれた。',
    'home.storyBody': 'YCH-YOYOは、中国全国2A部門で5回優勝し、中国人として初めてアジアパシフィック2Aタイトルを獲得したCheng Hao Yiによって設立・設計されています。伝説的なBlitzBallから最新のオフストリングモデルまで、すべてのヨーヨーにその経験が息づいています。',
    'home.atAGlance': 'YCH-YOYOの実績',
    'home.stat.products': 'コレクション商品数',
    'home.stat.athletes': 'チーム選手',
    'home.stat.titles': '全国2Aタイトル',
    'home.stat.first': '中国人初の2Aアジア王者',
    'home.stat.firstValue': '初',
    'home.meetTeam': 'チームを見る',
    'home.ready': 'プレイを始めますか？',
    'home.join': 'チャンピオンの仲間へ。',
    'home.finalSub': '最初の競技用ヨーヨーを選ぶか、自分のスタイルに合うモデルを見つけましょう。',
    'home.shop': 'コレクションを見る',
    'home.guide': 'BlitzBallとWind Ballの比較ガイド',
    'home.worldwide': '世界各地へ配送',
    'home.seeShipping': '配送情報を見る',
    'home.readStory': 'ストーリーを読む',
    'hero.eyebrow': '競技レベルの2A・4Aヨーヨー',
    'hero.titleFirst': '王者が生み出す。',
    'hero.titleSecond': '勝つための設計。',
    'hero.subtitle': '中国初の2Aアジアパシフィック王者Cheng Hao Yiの工房から。世界中の競技者が信頼するルーピングとオフストリングの性能。',
    'hero.watch': 'チャンピオンを見る',
    'hero.scroll': '実績までスクロール',
    'carousel.eyebrow': 'チャンピオンシップ・コレクション',
    'carousel.title': 'あらゆる成長段階に応えるヨーヨー。',
    'carousel.navigation': 'カルーセル操作',
    'carousel.previous': '前の商品',
    'carousel.next': '次の商品',
    'carousel.region': 'チャンピオンシップ・コレクション',
    'carousel.roleDescription': 'カルーセル',
    'carousel.view': '{{name}}を見る',
    'carousel.fromPrice': '{{price}}から',
    'carousel.explore': '詳しく見る',
    'carousel.tagline.1': '元祖チャンピオンのループ。',
    'carousel.tagline.8': '速さ。制御。途切れない流れ。',
    'carousel.tagline.21': '進化したWind Ball。',
    'carousel.tagline.14': '誰もが楽しめるオフストリング。',
    'carousel.tagline.6': 'Zirui Qiu シグネチャー。',
    'carousel.badge.1': 'チャンピオンシリーズ',
    'carousel.badge.8': 'ベストセラー',
    'carousel.badge.21': '新色',
    'carousel.badge.14': '4Aオフストリング',
    'carousel.badge.6': 'シグネチャー',
    'timeline.founderAlt': 'YCH-YOYO創設者 Cheng Hao Yi',
    'timeline.founder': '創設者・エンジニア',
    'timeline.quote': '「YCHのヨーヨーを手に取るすべての選手に、世界レベルの2Aを感じてもらいたい。」',
    'timeline.achievements': '競技実績',
    'timeline.title.1': '中国全国2A部門 5回優勝',
    'timeline.title.2': 'アイスランド世界大会 4位',
    'timeline.title.3': 'アジアパシフィック2A優勝',
    'timeline.title.4': '上海世界大会 5位',
    'timeline.note.first': '中国人初の2Aアジア王者',
    'timeline.tag.national': '全国',
    'timeline.tag.world': '世界',
    'timeline.tag.asiaPacific': 'アジアパシフィック',
    'timeline.videoTitle': 'Cheng Hao Yi パフォーマンス — YCH-YOYO',
    'windball.alt': 'Wind Ball ヨーヨー',
    'windball.pill': '主力モデル',
    'windball.subtitle': '軽く、丈夫で、いつまでも楽しい。',
    'windball.buy': '今すぐ購入',
  },
  'zh-CN': {
    'home.seoTitle': '亚太冠军 Cheng Hao Yi 打造的 2A 与 4A 竞技悠悠球',
    'home.seoDescription': '由中国首位2A亚太冠军Cheng Hao Yi设计的2A与4A竞技悠悠球。选购BlitzBall、Wind Ball、Rainbow Windball、Hidden Loong和Destiny。',
    'home.credentials': '品牌成绩',
    'home.trust.national': '5届中国全国冠军',
    'home.trust.asiaPacific': '2018年亚太2A冠军',
    'home.trust.first': '中国首位2A亚洲冠军',
    'home.trust.team': '9名团队选手',
    'home.storyEyebrow': '我们的故事',
    'home.storyTitle': '诞生于赛场。',
    'home.storyBody': 'YCH-YOYO由五届中国全国2A冠军、首位获得亚太2A冠军的中国选手Cheng Hao Yi创立并负责设计。从经典的BlitzBall到最新的离线系列，我们出品的每一颗悠悠球都传承着这份冠军经验。',
    'home.atAGlance': 'YCH-YOYO 概览',
    'home.stat.products': '系列商品',
    'home.stat.athletes': '团队选手',
    'home.stat.titles': '全国2A冠军',
    'home.stat.first': '中国首位2A亚洲冠军',
    'home.stat.firstValue': '首位',
    'home.meetTeam': '认识团队',
    'home.ready': '准备好开始了吗？',
    'home.join': '加入冠军行列。',
    'home.finalSub': '选择您的第一颗冠军级悠悠球，或了解哪款型号适合您的风格。',
    'home.shop': '选购系列',
    'home.guide': 'BlitzBall 与 Wind Ball 对比指南',
    'home.worldwide': '全球配送',
    'home.seeShipping': '查看配送信息',
    'home.readStory': '阅读我们的故事',
    'hero.eyebrow': '冠军级 2A 与 4A 悠悠球',
    'hero.titleFirst': '冠军打造。',
    'hero.titleSecond': '为胜利而设计。',
    'hero.subtitle': '来自中国首位2A亚太冠军Cheng Hao Yi的工作室。为全球选手打造值得信赖的回旋与离线性能。',
    'hero.watch': '观看冠军表现',
    'hero.scroll': '滚动查看品牌成绩',
    'carousel.eyebrow': '冠军系列',
    'carousel.title': '适合每个成长阶段的悠悠球。',
    'carousel.navigation': '轮播导航',
    'carousel.previous': '上一件商品',
    'carousel.next': '下一件商品',
    'carousel.region': '冠军系列',
    'carousel.roleDescription': '轮播',
    'carousel.view': '查看 {{name}}',
    'carousel.fromPrice': '{{price}} 起',
    'carousel.explore': '了解更多',
    'carousel.tagline.1': '冠军回旋的起点。',
    'carousel.tagline.8': '速度、控制、持续流动。',
    'carousel.tagline.21': '进化的Wind Ball。',
    'carousel.tagline.14': '让每个人都能享受离线。',
    'carousel.tagline.6': 'Zirui Qiu 签名款。',
    'carousel.badge.1': '冠军系列',
    'carousel.badge.8': '畅销款',
    'carousel.badge.21': '新颜色',
    'carousel.badge.14': '4A离线',
    'carousel.badge.6': '签名款',
    'timeline.founderAlt': 'YCH-YOYO创始人Cheng Hao Yi',
    'timeline.founder': '创始人兼工程师',
    'timeline.quote': '“我希望每位拿起YCH悠悠球的玩家，都能感受到真正的世界级2A。”',
    'timeline.achievements': '职业成绩',
    'timeline.title.1': '5届中国全国2A冠军',
    'timeline.title.2': '冰岛世界赛第4名',
    'timeline.title.3': '亚太2A冠军',
    'timeline.title.4': '上海世界赛第5名',
    'timeline.note.first': '中国首位2A亚洲冠军',
    'timeline.tag.national': '全国',
    'timeline.tag.world': '世界',
    'timeline.tag.asiaPacific': '亚太',
    'timeline.videoTitle': 'Cheng Hao Yi 表演 — YCH-YOYO',
    'windball.alt': 'Wind Ball 悠悠球',
    'windball.pill': '主力型号',
    'windball.subtitle': '轻盈、耐用，乐趣无穷。',
    'windball.buy': '立即购买',
  },
  'zh-TW': {
    'home.seoTitle': '亞太冠軍 Cheng Hao Yi 打造的 2A 與 4A 競技溜溜球',
    'home.seoDescription': '由中國首位2A亞太冠軍Cheng Hao Yi設計的2A與4A競技溜溜球。選購BlitzBall、Wind Ball、Rainbow Windball、Hidden Loong和Destiny。',
    'home.credentials': '品牌成績',
    'home.trust.national': '5屆中國全國冠軍',
    'home.trust.asiaPacific': '2018年亞太2A冠軍',
    'home.trust.first': '中國首位2A亞洲冠軍',
    'home.trust.team': '9名團隊選手',
    'home.storyEyebrow': '我們的故事',
    'home.storyTitle': '誕生於賽場。',
    'home.storyBody': 'YCH-YOYO由五屆中國全國2A冠軍、首位獲得亞太2A冠軍的中國選手Cheng Hao Yi創立並負責設計。從經典的BlitzBall到最新的離線系列，我們出品的每一顆溜溜球都傳承著這份冠軍經驗。',
    'home.atAGlance': 'YCH-YOYO 概覽',
    'home.stat.products': '系列商品',
    'home.stat.athletes': '團隊選手',
    'home.stat.titles': '全國2A冠軍',
    'home.stat.first': '中國首位2A亞洲冠軍',
    'home.stat.firstValue': '首位',
    'home.meetTeam': '認識團隊',
    'home.ready': '準備好開始了嗎？',
    'home.join': '加入冠軍行列。',
    'home.finalSub': '選擇您的第一顆冠軍級溜溜球，或瞭解哪款型號適合您的風格。',
    'home.shop': '選購系列',
    'home.guide': 'BlitzBall 與 Wind Ball 比較指南',
    'home.worldwide': '全球配送',
    'home.seeShipping': '查看配送資訊',
    'home.readStory': '閱讀我們的故事',
    'hero.eyebrow': '冠軍級 2A 與 4A 溜溜球',
    'hero.titleFirst': '冠軍打造。',
    'hero.titleSecond': '為勝利而設計。',
    'hero.subtitle': '來自中國首位2A亞太冠軍Cheng Hao Yi的工作室。為全球選手打造值得信賴的迴旋與離線性能。',
    'hero.watch': '觀看冠軍表現',
    'hero.scroll': '捲動查看品牌成績',
    'carousel.eyebrow': '冠軍系列',
    'carousel.title': '適合每個成長階段的溜溜球。',
    'carousel.navigation': '輪播導覽',
    'carousel.previous': '上一件商品',
    'carousel.next': '下一件商品',
    'carousel.region': '冠軍系列',
    'carousel.roleDescription': '輪播',
    'carousel.view': '查看 {{name}}',
    'carousel.fromPrice': '{{price}} 起',
    'carousel.explore': '瞭解更多',
    'carousel.tagline.1': '冠軍迴旋的起點。',
    'carousel.tagline.8': '速度、控制、持續流動。',
    'carousel.tagline.21': '進化的Wind Ball。',
    'carousel.tagline.14': '讓每個人都能享受離線。',
    'carousel.tagline.6': 'Zirui Qiu 簽名款。',
    'carousel.badge.1': '冠軍系列',
    'carousel.badge.8': '暢銷款',
    'carousel.badge.21': '新顏色',
    'carousel.badge.14': '4A離線',
    'carousel.badge.6': '簽名款',
    'timeline.founderAlt': 'YCH-YOYO創辦人Cheng Hao Yi',
    'timeline.founder': '創辦人兼工程師',
    'timeline.quote': '「我希望每位拿起YCH溜溜球的玩家，都能感受到真正的世界級2A。」',
    'timeline.achievements': '職業成績',
    'timeline.title.1': '5屆中國全國2A冠軍',
    'timeline.title.2': '冰島世界賽第4名',
    'timeline.title.3': '亞太2A冠軍',
    'timeline.title.4': '上海世界賽第5名',
    'timeline.note.first': '中國首位2A亞洲冠軍',
    'timeline.tag.national': '全國',
    'timeline.tag.world': '世界',
    'timeline.tag.asiaPacific': '亞太',
    'timeline.videoTitle': 'Cheng Hao Yi 表演 — YCH-YOYO',
    'windball.alt': 'Wind Ball 溜溜球',
    'windball.pill': '主力型號',
    'windball.subtitle': '輕盈、耐用，樂趣無窮。',
    'windball.buy': '立即購買',
  },
  fr: {
    'home.seoTitle': 'Yo-yos 2A et 4A de compétition par le champion Asie-Pacifique Cheng Hao Yi',
    'home.seoDescription': 'Yo-yos 2A et 4A conçus par Cheng Hao Yi, premier champion chinois Asie-Pacifique de 2A. Découvrez BlitzBall, Wind Ball, Rainbow Windball, Hidden Loong et Destiny.',
    'home.credentials': 'Palmarès de la marque',
    'home.trust.national': '5× champion national de Chine',
    'home.trust.asiaPacific': 'Champion Asie-Pacifique 2A 2018',
    'home.trust.first': 'Premier champion asiatique chinois de 2A',
    'home.trust.team': '9 athlètes dans l’équipe',
    'home.storyEyebrow': 'Notre histoire',
    'home.storyTitle': 'Né de la compétition.',
    'home.storyBody': 'YCH-YOYO a été fondé et est conçu par Cheng Hao Yi, quintuple champion national chinois de 2A et premier joueur chinois à remporter le titre Asie-Pacifique de 2A. Du légendaire BlitzBall aux nouveaux modèles offstring, chaque yo-yo bénéficie de cette expérience.',
    'home.atAGlance': 'YCH-YOYO en bref',
    'home.stat.products': 'Produits dans la collection',
    'home.stat.athletes': 'Athlètes de l’équipe',
    'home.stat.titles': 'Titres nationaux 2A',
    'home.stat.first': 'Premier champion asiatique chinois de 2A',
    'home.stat.firstValue': '1er',
    'home.meetTeam': 'Découvrir l’équipe',
    'home.ready': 'Prêt à jouer ?',
    'home.join': 'Rejoignez les champions.',
    'home.finalSub': 'Choisissez votre premier yo-yo de niveau compétition ou trouvez le modèle adapté à votre style.',
    'home.shop': 'Voir la collection',
    'home.guide': 'Guide BlitzBall ou Wind Ball',
    'home.worldwide': 'Livraison internationale',
    'home.seeShipping': 'Voir la livraison',
    'home.readStory': 'Lire notre histoire',
    'hero.eyebrow': 'Yo-yos 2A et 4A de niveau compétition',
    'hero.titleFirst': 'Créés par des champions.',
    'hero.titleSecond': 'Conçus pour gagner.',
    'hero.subtitle': 'Issus de l’atelier de Cheng Hao Yi, premier champion chinois Asie-Pacifique de 2A. Des performances de looping et offstring reconnues par les compétiteurs du monde entier.',
    'hero.watch': 'Voir le champion',
    'hero.scroll': 'Accéder au palmarès',
    'carousel.eyebrow': 'Collection des champions',
    'carousel.title': 'Un yo-yo pour chaque étape de votre progression.',
    'carousel.navigation': 'Navigation du carrousel',
    'carousel.previous': 'Produit précédent',
    'carousel.next': 'Produit suivant',
    'carousel.region': 'Collection des champions',
    'carousel.roleDescription': 'carrousel',
    'carousel.view': 'Voir {{name}}',
    'carousel.fromPrice': 'À partir de {{price}}',
    'carousel.explore': 'Découvrir',
    'carousel.tagline.1': 'Le looping du champion original.',
    'carousel.tagline.8': 'Vitesse. Contrôle. Fluidité infinie.',
    'carousel.tagline.21': 'Le Wind Ball réinventé.',
    'carousel.tagline.14': 'L’offstring accessible à tous.',
    'carousel.tagline.6': 'Signature Zirui Qiu.',
    'carousel.badge.1': 'Série champion',
    'carousel.badge.8': 'Meilleure vente',
    'carousel.badge.21': 'Nouvelle couleur',
    'carousel.badge.14': 'Offstring 4A',
    'carousel.badge.6': 'Signature',
    'timeline.founderAlt': 'Cheng Hao Yi, fondateur de YCH-YOYO',
    'timeline.founder': 'Fondateur et ingénieur',
    'timeline.quote': '« Je veux que chaque joueur qui prend un yo-yo YCH ressente ce que signifie vraiment un 2A de niveau mondial. »',
    'timeline.achievements': 'Palmarès sportif',
    'timeline.title.1': '5× champion national chinois de 2A',
    'timeline.title.2': '4e au championnat du monde en Islande',
    'timeline.title.3': 'Champion Asie-Pacifique de 2A',
    'timeline.title.4': '5e au championnat du monde de Shanghai',
    'timeline.note.first': 'Premier champion asiatique chinois de 2A',
    'timeline.tag.national': 'National',
    'timeline.tag.world': 'Mondial',
    'timeline.tag.asiaPacific': 'Asie-Pacifique',
    'timeline.videoTitle': 'Démonstration de Cheng Hao Yi — YCH-YOYO',
    'windball.alt': 'Yo-yo Wind Ball',
    'windball.pill': 'Notre modèle phare',
    'windball.subtitle': 'Léger, résistant et toujours amusant.',
    'windball.buy': 'Acheter',
  },
  es: {
    'home.seoTitle': 'Yo-yos 2A y 4A de competición por el campeón de Asia-Pacífico Cheng Hao Yi',
    'home.seoDescription': 'Yo-yos 2A y 4A diseñados por Cheng Hao Yi, primer campeón chino de Asia-Pacífico en 2A. Descubre BlitzBall, Wind Ball, Rainbow Windball, Hidden Loong y Destiny.',
    'home.credentials': 'Logros de la marca',
    'home.trust.national': '5 veces campeón nacional de China',
    'home.trust.asiaPacific': 'Campeón de Asia-Pacífico 2A en 2018',
    'home.trust.first': 'Primer campeón asiático chino de 2A',
    'home.trust.team': '9 atletas en el equipo',
    'home.storyEyebrow': 'Nuestra historia',
    'home.storyTitle': 'Nacido de la competición.',
    'home.storyBody': 'YCH-YOYO fue fundado y es diseñado por Cheng Hao Yi, cinco veces campeón nacional chino de 2A y primer jugador chino en ganar el título de Asia-Pacífico 2A. Desde el legendario BlitzBall hasta los nuevos modelos offstring, cada yo-yo refleja esa experiencia.',
    'home.atAGlance': 'YCH-YOYO de un vistazo',
    'home.stat.products': 'Productos en la colección',
    'home.stat.athletes': 'Atletas del equipo',
    'home.stat.titles': 'Títulos nacionales 2A',
    'home.stat.first': 'Primer campeón asiático chino de 2A',
    'home.stat.firstValue': '1.º',
    'home.meetTeam': 'Conoce al equipo',
    'home.ready': '¿Listo para jugar?',
    'home.join': 'Únete a los campeones.',
    'home.finalSub': 'Elige tu primer yo-yo de nivel competición o descubre qué modelo se adapta a tu estilo.',
    'home.shop': 'Ver la colección',
    'home.guide': 'Guía BlitzBall vs Wind Ball',
    'home.worldwide': 'Envíos internacionales',
    'home.seeShipping': 'Ver envíos',
    'home.readStory': 'Leer nuestra historia',
    'hero.eyebrow': 'Yo-yos 2A y 4A de nivel competición',
    'hero.titleFirst': 'Creados por campeones.',
    'hero.titleSecond': 'Diseñados para ganar.',
    'hero.subtitle': 'Desde el taller de Cheng Hao Yi, primer campeón chino de Asia-Pacífico en 2A. Rendimiento de looping y offstring en el que confían competidores de todo el mundo.',
    'hero.watch': 'Ver al campeón',
    'hero.scroll': 'Ir a los logros',
    'carousel.eyebrow': 'Colección de campeones',
    'carousel.title': 'Un yo-yo para cada etapa de tu progreso.',
    'carousel.navigation': 'Navegación del carrusel',
    'carousel.previous': 'Producto anterior',
    'carousel.next': 'Producto siguiente',
    'carousel.region': 'Colección de campeones',
    'carousel.roleDescription': 'carrusel',
    'carousel.view': 'Ver {{name}}',
    'carousel.fromPrice': 'Desde {{price}}',
    'carousel.explore': 'Descubrir',
    'carousel.tagline.1': 'El looping del campeón original.',
    'carousel.tagline.8': 'Velocidad. Control. Fluidez infinita.',
    'carousel.tagline.21': 'El Wind Ball, evolucionado.',
    'carousel.tagline.14': 'Offstring para todos.',
    'carousel.tagline.6': 'Signature de Zirui Qiu.',
    'carousel.badge.1': 'Serie campeón',
    'carousel.badge.8': 'Más vendido',
    'carousel.badge.21': 'Nuevo color',
    'carousel.badge.14': 'Offstring 4A',
    'carousel.badge.6': 'Signature',
    'timeline.founderAlt': 'Cheng Hao Yi, fundador de YCH-YOYO',
    'timeline.founder': 'Fundador e ingeniero',
    'timeline.quote': '«Quiero que cada jugador que tome un yo-yo YCH sienta lo que significa realmente el 2A de nivel mundial».',
    'timeline.achievements': 'Logros deportivos',
    'timeline.title.1': '5 veces campeón nacional chino de 2A',
    'timeline.title.2': '4.º en el Mundial de Islandia',
    'timeline.title.3': 'Campeón de Asia-Pacífico 2A',
    'timeline.title.4': '5.º en el Mundial de Shanghái',
    'timeline.note.first': 'Primer campeón asiático chino de 2A',
    'timeline.tag.national': 'Nacional',
    'timeline.tag.world': 'Mundial',
    'timeline.tag.asiaPacific': 'Asia-Pacífico',
    'timeline.videoTitle': 'Actuación de Cheng Hao Yi — YCH-YOYO',
    'windball.alt': 'Yo-yo Wind Ball',
    'windball.pill': 'Nuestro modelo estrella',
    'windball.subtitle': 'Ligero, resistente y siempre divertido.',
    'windball.buy': 'Comprar ahora',
  },
  ko: {
    'home.seoTitle': '아시아 태평양 챔피언 Cheng Hao Yi가 만든 2A 및 4A 대회용 요요',
    'home.seoDescription': '중국 최초 2A 아시아 태평양 챔피언 Cheng Hao Yi가 설계한 2A 및 4A 요요. BlitzBall, Wind Ball, Rainbow Windball, Hidden Loong과 Destiny를 만나보세요.',
    'home.credentials': '브랜드 성과',
    'home.trust.national': '중국 전국 챔피언 5회',
    'home.trust.asiaPacific': '2018 아시아 태평양 2A 챔피언',
    'home.trust.first': '중국 최초 2A 아시아 챔피언',
    'home.trust.team': '팀 선수 9명',
    'home.storyEyebrow': '우리의 이야기',
    'home.storyTitle': '대회에서 탄생하다.',
    'home.storyBody': 'YCH-YOYO는 중국 전국 2A 챔피언 5회이자 중국 최초 아시아 태평양 2A 우승자인 Cheng Hao Yi가 설립하고 설계합니다. 전설적인 BlitzBall부터 최신 오프스트링 제품까지 모든 요요에 그 경험이 담겨 있습니다.',
    'home.atAGlance': 'YCH-YOYO 한눈에 보기',
    'home.stat.products': '컬렉션 상품',
    'home.stat.athletes': '팀 선수',
    'home.stat.titles': '전국 2A 타이틀',
    'home.stat.first': '중국 최초 2A 아시아 챔피언',
    'home.stat.firstValue': '최초',
    'home.meetTeam': '팀 만나기',
    'home.ready': '플레이할 준비가 되셨나요?',
    'home.join': '챔피언과 함께하세요.',
    'home.finalSub': '첫 대회용 요요를 선택하거나 자신의 스타일에 맞는 모델을 찾아보세요.',
    'home.shop': '컬렉션 쇼핑',
    'home.guide': 'BlitzBall과 Wind Ball 비교 가이드',
    'home.worldwide': '전 세계 배송',
    'home.seeShipping': '배송 정보 보기',
    'home.readStory': '우리 이야기 읽기',
    'hero.eyebrow': '대회급 2A 및 4A 요요',
    'hero.titleFirst': '챔피언이 만들다.',
    'hero.titleSecond': '승리를 위해 설계하다.',
    'hero.subtitle': '중국 최초 2A 아시아 태평양 챔피언 Cheng Hao Yi의 작업실에서 시작됩니다. 전 세계 선수들이 신뢰하는 루핑과 오프스트링 성능을 경험하세요.',
    'hero.watch': '챔피언 영상 보기',
    'hero.scroll': '성과로 스크롤',
    'carousel.eyebrow': '챔피언십 컬렉션',
    'carousel.title': '모든 성장 단계에 맞는 요요.',
    'carousel.navigation': '캐러셀 탐색',
    'carousel.previous': '이전 상품',
    'carousel.next': '다음 상품',
    'carousel.region': '챔피언십 컬렉션',
    'carousel.roleDescription': '캐러셀',
    'carousel.view': '{{name}} 보기',
    'carousel.fromPrice': '{{price}}부터',
    'carousel.explore': '자세히 보기',
    'carousel.tagline.1': '오리지널 챔피언의 루프.',
    'carousel.tagline.8': '속도. 제어. 끝없는 흐름.',
    'carousel.tagline.21': '진화한 Wind Ball.',
    'carousel.tagline.14': '누구나 즐기는 오프스트링.',
    'carousel.tagline.6': 'Zirui Qiu 시그니처.',
    'carousel.badge.1': '챔피언 시리즈',
    'carousel.badge.8': '베스트셀러',
    'carousel.badge.21': '새 색상',
    'carousel.badge.14': '4A 오프스트링',
    'carousel.badge.6': '시그니처',
    'timeline.founderAlt': 'YCH-YOYO 설립자 Cheng Hao Yi',
    'timeline.founder': '설립자 겸 엔지니어',
    'timeline.quote': '“YCH 요요를 잡는 모든 선수가 세계적인 2A가 무엇인지 느끼길 바랍니다.”',
    'timeline.achievements': '선수 경력',
    'timeline.title.1': '중국 전국 2A 챔피언 5회',
    'timeline.title.2': '아이슬란드 세계대회 4위',
    'timeline.title.3': '아시아 태평양 2A 챔피언',
    'timeline.title.4': '상하이 세계대회 5위',
    'timeline.note.first': '중국 최초 2A 아시아 챔피언',
    'timeline.tag.national': '전국',
    'timeline.tag.world': '세계',
    'timeline.tag.asiaPacific': '아시아 태평양',
    'timeline.videoTitle': 'Cheng Hao Yi 퍼포먼스 — YCH-YOYO',
    'windball.alt': 'Wind Ball 요요',
    'windball.pill': '대표 모델',
    'windball.subtitle': '가볍고 튼튼하며 끝없이 즐겁습니다.',
    'windball.buy': '지금 구매',
  },
};
